<template>
  <div>
    <div class="page-result">
      <div class="state-box" v-show="contentShow">
        <img :src="errorImg" alt="" />
        <p>{{ errorMsg }}</p>
        <div v-show="retryBtnShow">
          <span @click="retryView">点击重试</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      contentShow: true,
      errorState: '',
      errorMsg: '您访问的页面找不到了~',
      errorImg: require('../assets/img-m/404.png'),
      retryBtnShow: true
    }
  },
  beforeMount() {
    this.errorState = this.$route.query.errorState || ''
    this.showPage()
  },
  methods: {
    showPage() {
      switch (this.errorState) {
        case '404':
          {
            this.errorMsg = '您访问的页面找不到了~'
            this.errorImg = require('../assets/img-m/404.png')
          }
          break
        case '503':
          {
            this.errorMsg = '服务器未响应~'
            this.errorImg = require('../assets/img-m/503.png')
          }
          break
        case 'noNetwork':
          {
            this.errorMsg = '无法连接网络，请检查网络或重试~'
            this.errorImg = require('../assets/img-m/no-network.png')
          }
          break
        case 'requestFail':
          {
            this.retryBtnShow = false
            this.errorMsg = '请求失败，请稍后重试~'
            this.errorImg = require('../assets/img-m/request-fail.png')
          }
          break
        case 'noPermission':
          {
            this.contentShow = false
            this.$dialog
              .confirm({
                title: '无权限温馨提示',
                message:
                  '您为个人用户无访问权限，请先至服贸会官网-账户中心完善资质。',
                confirmButtonColor: '#FE8E08'
              })
              .then(() => {
                // on confirm
              })
              .catch(() => {
                // on cancel
              })
          }
          break
        default:
          break
      }
    },
    retryView() {
      // try {
      //   window.bridge.onShowShareButton ({
      //     "source": "活动咨询",
      //     "isShow": true,
      //   })
      // } catch (error) {
      //   console.log('APP调起分享按钮监听失败')
      // };
    }
  }
}
</script>
<style lang="scss">
.state-box {
  > img {
    width: 3.6rem;
    display: block;
    margin: 2rem auto 0;
  }
  > p {
    font-size: 0.3rem;
    color: #333;
    text-align: center;
    padding-top: 0.9rem;
  }
  > div {
    text-align: center;
    span {
      display: inline-block;
      font-size: 0.28rem;
      color: #bbbbbb;
      border: 1px solid #bbbbbb;
      width: 2.4rem;
      height: 0.8rem;
      line-height: 0.8rem;
      border-radius: 0.4rem;
    }
  }
}
</style>
